import { useSeo } from "../lib/seo";
import { SERVICES } from "../data/content";
import { Container, Btn, CheckList } from "../components/site/Ui";
import { Reveal } from "../components/site/Motion";
import { PageHero, CtaBand } from "../components/site/Blocks";

export default function Solutions() {
  useSeo("Solutions", "Affiliate marketing, CPI, CPA, lead generation, media buying, user acquisition, influencer and performance marketing solutions from AppTarget.", "/solutions");
  return (
    <>
      <PageHero eyebrow="Solutions" lines={["Every service, built", "around performance."]} testid="solutions-hero"
        text="Choose one service or combine several. Each is structured around clear outcomes, quality partners and transparent communication.">
        <div className="flex flex-wrap gap-2">
          {SERVICES.map((s) => (
            <a key={s.slug} href={`#${s.slug}`} data-testid={`solutions-jump-${s.slug}`} className="rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-[#102B50] transition-colors hover:border-[#2878E5] hover:text-[#2878E5]">{s.title}</a>
          ))}
        </div>
      </PageHero>
      {SERVICES.map((s, i) => (
        <section key={s.slug} id={s.slug} data-testid={`solution-${s.slug}`} className={`scroll-mt-24 py-16 lg:py-24 ${i % 2 ? "bg-white" : "bg-[#F4F7FB]"}`}>
          <Container className="grid items-start gap-10 lg:grid-cols-12">
            <Reveal className="lg:col-span-5">
              <div className="flex items-center gap-4">
                <span className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-[#102B50] text-white"><s.icon className="h-6 w-6" /></span>
                <span className="font-display text-sm font-bold text-slate-400">{String(i + 1).padStart(2, "0")} / 08</span>
              </div>
              <h2 className="mt-6 font-display text-3xl font-bold tracking-tight text-[#102B50] sm:text-4xl">{s.title}</h2>
              <p className="mt-4 text-base leading-relaxed text-[#4A5D78] md:text-lg">{s.long}</p>
            </Reveal>
            <Reveal delay={0.1} className="card-soft p-8 lg:col-span-7 lg:p-10">
              <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-[#2878E5]">What’s included</h3>
              <div className="mt-6"><CheckList items={s.points} /></div>
              <div className="mt-8 flex flex-wrap gap-3 border-t border-slate-100 pt-8">
                <Btn to="/advertisers" data-testid={`solution-cta-${s.slug}`}>Launch a Campaign</Btn>
                <Btn to="/contact" variant="outline" arrow={false}>Ask a Question</Btn>
              </div>
            </Reveal>
          </Container>
        </section>
      ))}
      <CtaBand />
    </>
  );
}
